import { render, staticRenderFns } from "./Informacoes.vue?vue&type=template&id=1bf22e58&scoped=true"
import script from "./Informacoes.vue?vue&type=script&lang=js"
export * from "./Informacoes.vue?vue&type=script&lang=js"
import style0 from "./Informacoes.vue?vue&type=style&index=0&id=1bf22e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf22e58",
  null
  
)

export default component.exports